import { CheckCircleIcon } from "@/components/icons/check-circle-icon";
import ImageWithLoading from "@/components/image/image-with-loading";
import { cn } from "@/utils/cn";

interface SupermarketCardProps {
  option: string;
  logoSrc: string | undefined;
  isSelected: boolean;
  isDisabled: boolean;
  onSelect: () => void;
}

export const SupermarketCard = ({
  option,
  logoSrc,
  isSelected,
  isDisabled,
  onSelect,
}: SupermarketCardProps) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={isDisabled}
      className={cn(
        "border-border-li-default h-[97px] w-[97px] rounded-xl border bg-white",
        "relative flex items-center justify-center",
        {
          "border-primary-default border": isSelected,
        },
      )}
      aria-label={`Select ${option}`}
      aria-pressed={isSelected}
    >
      <ImageWithLoading
        src={logoSrc ?? ""}
        alt={option}
        classNames={{
          container: "w-16 h-16",
          image: "w-16 h-16 object-contain bg-white",
        }}
      />
      {isSelected && <CheckCircleIcon className="absolute top-1 right-1" />}
    </button>
  );
};
